<ng-container *ngIf="initialized">
  <form class="form" #myForm="ngForm" (ngSubmit)="onSave()" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="!expense" class="modal-title" id="exampleModalLabel">Add Expense</h5>
        <h5 *ngIf="expense" class="modal-title" id="exampleModalLabel">Edit Expense</h5>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>

        <div class="form-group">
          <label for="exampleFormControlInput1">Description</label>
          <input type="text" [(ngModel)]="model.description" name="description" class="form-control" />
          <div class="invalid-message">
            <div>Description is required</div>
          </div>
        </div>

        <div class="form-group">
          <label for="exampleFormControlInput1">Date</label>
          <kendo-datepicker class="form-control" placeholder="" [(ngModel)]="model.date" name="date"></kendo-datepicker>
          <div class="invalid-message">
            <div>Date is required</div>
          </div>
        </div>
        <div class="form-group">
          <label for="exampleFormControlInput1">Amount</label>
          <kendo-numerictextbox [format]="'c'" [min]="0" class="form-control" [(ngModel)]="model.amount" name="amount"></kendo-numerictextbox>
          <div class="invalid-message">
            <div>Date is required</div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <h6>Receipt Image:</h6>
            <div class="form-group">
              <azure-file-upload #receiptImage [acceptedFileTypes]="['application/pdf','image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff', 'image/svg+xml']" [azureContainer]="'images'" [src]="'/fetchImage?filename=' + (model.receiptImage | encodeUrl)" [(ngModel)]="model.receiptImage" name="receiptImage" [existingFileType]="model.fileType" [existingFileName]="model.fileName"></azure-file-upload>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button  class="btn btn-sm btn-secondary mr-2" [promiseBtn]="submitComplete" type="submit">Save</button>
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
